import React from "react";
import "./logoCarousel.scss";
import logo1 from "../../assets/logos/1.png";
import logo2 from "../../assets/logos/2.png";
import logo3 from "../../assets/logos/3.png";
import logo4 from "../../assets/logos/4.png";
import logo5 from "../../assets/logos/5.png";
import logo6 from "../../assets/logos/6.png";
import logo7 from "../../assets/logos/7.png";
import logo8 from "../../assets/logos/8.png";
import { useLanguage } from "../../LanguageContext";
import { useNavigate } from "react-router-dom";


const LogoCarousel = () => {
  const navigate = useNavigate();
  const { t } = useLanguage(); // 👈 translation function
  const slides = [
   logo1,
   logo2,
   logo3,
   logo4,
   logo5,
   logo6,
   logo7,
   logo8,
  ];

  return (
    
    <div className="logo-carousel">
      <p>{t("logo_carousel_title")}</p>
      <div className="slider">
        <div className="slide-track">
          {/* First set of slides */}
        {slides.map((src, index) => (
          <div className="slide" key={`slide-${index}`}>
            <img src={src} alt={`Brand ${index + 1}`} />
          </div>
        ))}
        {/* Duplicate set of slides for seamless loop */}
        {slides.map((src, index) => (
          <div className="slide" key={`slide-duplicate-${index}`}>
            <img src={src} alt={`Brand ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default LogoCarousel;
